import { CreateLinkTo } from "shared/constants/linkTo";

export function copyLinkBook(bookId: string, toasts?: any, t?: any) {

    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.book(bookId))
        .then(() => toasts.info(t && t('link_copied')));
}

export function copyLinkChildrensBook(bookId: string, toasts?: any, t?: any) {

    navigator.clipboard
        .writeText(window.location.origin + '/cb/' + bookId)
        .then(() => toasts.info('Ссылка скопирована'));
}

export function createCopyLinkBookFn(toasts?: any, t?: any) {
    return (bookId: string) => copyLinkBook(bookId, toasts, t);
}
import { CreateLinkTo } from "shared/constants/linkTo";

export function copyLinkBook(bookId: string, toasts?: any, t?: any) {

    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.book(bookId))
        .then(() => toasts.info(t && t('link_copied')));
}

export function copyLinkChildrensBook(bookId: string, toasts?: any, t?: any) {

    navigator.clipboard
        .writeText(window.location.origin + '/cb/' + bookId)
        .then(() => toasts.info('Ссылка скопирована'));
}

export function createCopyLinkBookFn(toasts?: any, t?: any) {
    return (bookId: string) => copyLinkBook(bookId, toasts, t);
}
